var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6499,
    cy: 45.6504,
    r: 45,
    fill: "#C0B6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2087 8.52285L20.2621 8.48633V8.52285H20.2087Z",
    fill: "#131516"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.216 88.2464C57.7991 86.8751 55.3242 85.5858 52.8545 84.2991L52.8505 84.2971C52.0613 83.8859 51.2725 83.475 50.4864 83.0618L40.2949 77.6343C39.5437 77.2361 38.7836 76.8448 38.0223 76.4529L38.0217 76.4526L38.0214 76.4524C36.3534 75.5938 34.679 74.7319 33.0763 73.7862L33.081 24.5754C33.0799 24.0403 33.0736 23.505 33.0673 22.9696C33.0595 22.3004 33.0517 21.6312 33.0538 20.9626C33.0545 20.7432 33.0607 20.5226 33.067 20.3015C33.0807 19.8166 33.0945 19.3297 33.05 18.8504L52.1553 18.8506C54.4901 18.82 56.825 18.8179 59.1598 18.8442C59.4567 18.8469 59.7577 18.8436 60.0602 18.8403C60.8034 18.8323 61.5556 18.8241 62.2799 18.9039C62.0239 19.0039 60.4762 19.1323 59.3713 19.224L59.3711 19.224L59.3701 19.2241C58.9211 19.2614 58.5454 19.2926 58.3594 19.3133L43.4704 20.866C42.9 20.9291 42.2883 20.984 41.6619 21.0402C40.1773 21.1735 38.6095 21.3142 37.3104 21.5888L37.2903 64.2211C37.2903 64.8896 37.2874 65.5585 37.2844 66.2275V66.2306C37.2772 67.8801 37.2699 69.5304 37.3067 71.178C40.8933 71.5556 44.4748 71.977 48.0513 72.4421L66.0703 74.6458L73.0387 75.4766C73.5258 75.5378 74.0135 75.6028 74.5018 75.6678L74.5034 75.668C75.9086 75.8552 77.3179 76.0429 78.7279 76.1444C73.7126 81.5895 67.3712 85.7943 60.216 88.2464Z",
    fill: "#131516"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.083 44.8171C41.2335 44.8795 41.3949 44.9115 41.5578 44.9115V42.4305C41.3949 42.4305 41.2335 42.4626 41.083 42.5249C40.9325 42.5873 40.7958 42.6786 40.6806 42.7938C40.5654 42.909 40.474 43.0458 40.4117 43.1963C40.3493 43.3468 40.3172 43.5081 40.3172 43.671C40.3172 43.8339 40.3493 43.9952 40.4117 44.1458C40.474 44.2963 40.5654 44.433 40.6806 44.5482C40.7958 44.6634 40.9325 44.7548 41.083 44.8171Z",
    fill: "#131516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.9c34cf8b687e4f5b883f4ed8e3d9b885.svg";
export { ForwardRef as ReactComponent };